import { Box, HStack } from '@chakra-ui/react'

interface DotProps {
  color?: string
}

const DotDivider: React.FC<DotProps> = ({ color }) => (
  <HStack justifyContent="center" alignItems="center">
    {[1, 2, 3].map(v => (
      <Dot key={v} color={color} />
    ))}
  </HStack>
)

const Dot: React.FC<DotProps> = ({ color = 'paleWhite' }) => (
  <Box h="2" w="2" bg={color} />
)

export default DotDivider
